import Enum from "@/utils/enum.js";

// 绑定手机号
export const BIND_ENUM = {
  NOT_BIND: 0,
  ALREADY_BIND: 1,
};

// 活动状态图标
export const MESSAGE_IMAGE_ENUM = {
  FAIL: require("@/images/activity_fail.png"),
  FIGHTING: require("@/images/activity_fighting.png"),
  COURIER: require("@/images/activity_courier.png"),
};

// 活动按钮文案
export const ACTIVITY_BTN_TEXT_ENUM = {
  INVITE: "立即邀请",
  DISCOUNT: "拼团拿5折券",
  HELP: "点击帮TA拼团，拿3元券",
  MAIL: "立即寄件再拿优惠券",
}

// 打折券文案
export const COUPON_DISCOUNT_TEXT_ENUM = {
  SF: '恭喜您领取成功！可前往”顺丰速运微信公众号-寄快递-丰巢寄件”，进行使用',
  YD: '恭喜您领取成功！可前往“韵达快递微信公众号-我要寄件-丰巢自寄”，进行使用',
  YTO: '恭喜您领取成功！可前往“圆通速递微信公众号-寄件-丰巢自寄”，进行使用',
  FC: '恭喜您领取成功！可前往“丰巢智能柜公众号-个人中心-我的资料-优惠券”查看并使用',
}

// 渠道标识枚举
export const CHANNEL_CODE_ENUM = new Enum({
  SF: "e-sf",
  YD: "e-yd",
  YTO: "e-yto",
  FC: "e-fc",
});

// 渠道图片与文案
export const CHANNEL_CONTENT_ENUM = {
  SF: {
    image: require("@/images/sf_logo.png"),
    text: "寄顺丰用丰巢 &nbsp;&nbsp;24小时随时寄",
  },
  YD: {
    image: require("@/images/yd_logo.png"),
    text: "寄韵达用丰巢 &nbsp;&nbsp;24小时随时寄",
  },
  YTO: {
    image: require("@/images/yto_logo.png"),
    text: "寄圆通用丰巢 &nbsp;&nbsp;24小时随时寄",
  },
  FC: {
    image: "",
    text: "寄快递用丰巢 &nbsp;24小时想寄就寄"
  }
}

// 优惠券图标枚举
export const COUPON_IMAGE_ENUM = {
  DEDUCTION_1: require("@/images/1_yuan_coupon.png"),
  DEDUCTION_3: require("@/images/3_yuan_coupon.png"),
  DISCOUNT: require("@/images/5_discount_coupon.png"),
}

// 领取提示枚举
export const RECEIVE_INSTRUCTION_ENUM = {
  GROUP: "2人成团，免费拿5折券",
  HELP: "帮TA拼团，立即拿3元立减券",
  MAIL: "寄完1件立拿免费券，再寄1件狂揽40元券包"
};

// 领券进度枚举
export const COUPON_RECEIVE_PROGRESS_ENUM = {
  BEGIN: 0,     // 一个都没领
  DISCOUNT: 1,  // 打折
  FREE: 2,     // 免费
  PARCEL: 3,   // 券包
}

// 拼团人员头像为空枚举
export const GROUP_MEMBER_IMAGE_ENUM = {
  LEADER: require("@/images/team_leader.png"),
  MEMBER: require("@/images/team_member.png"),
  EMPTY: require("@/images/team_placeholder.png"),
}

// 拼团状态
export const GROUP_STATUS_ENUM = {
  NOT_FULL: 1,    // 团未满
  FULL: 2,  // 团满
}

// 浏览器环境
export const BROWSER_ENV_ENUM = {
  WECHAT: "wechat",
  CONSUMER_APP: "consumer_app",
  ALIPAY: "alipay",
  OTHERS: "others",
}